import { render } from "./Paket.vue?vue&type=template&id=5ca4d583&scoped=true"
import script from "./Paket.vue?vue&type=script&lang=js"
export * from "./Paket.vue?vue&type=script&lang=js"

import "./Paket.vue?vue&type=style&index=0&id=5ca4d583&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5ca4d583"

export default script